import { LoggedUserDetails } from "app/management/excess/loggeduserdetail.pojo";
export class RoomTypeMasterPojo {
    roomTypeId: number;
    roomType: string;
    roomRegionId: number;
    roomAmount: number;
    maximumNoOfPerson: number;
    maximumNoOfRooms: number;
    maximumNoOfDays: number;
    numberOfRoomsPerPerson: number;
    tax: number;
    cottageId: number;
    onlineFlag: string;
    depositAmount: number;
    maximumExtraPersons:number;
    amountPerExtraPerson:number;
    onlineDepositAmount:number;


    sgstPercentage: number = 0; 
    cgstPercentage: number = 0; 
    igstPercentage: number = 0;
    sgstAmount: number =0;
    cgstAmount: number =0;
    igstAmount: number =0;
    taxable: number =0;
    taxamount: number =0;
    loggedUserDetails = new LoggedUserDetails();
    date: string;
    time: string;
    checkInDate: any;
    checkInTime: any;
}